import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { LocaleService } from '@app/core/i18n';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { UserUtilsService } from '@app/library/services/user-utils.service';
import { IPageParam, IPageLanding } from '@vestiaire/vc-angular-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { BasePageComponentDirective } from '@app/library/components/base-page.component';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { SetPageParams } from '@app/core/header/store/actions';
import { Persist } from '@app/analytics/actions/data-layer';
import { SearchStateMappingService } from '@app/core/search/services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalDeliveryServiceDescriptionComponent } from '@app/shared/components/modals/modal-delivery-service-description/modal-delivery-service-description.component';
import { TransferState, Meta } from '@angular/platform-browser';

@Component({
  selector: 'vc-cms-landing',
  templateUrl: './cms-landing.component.html',
  styleUrls: ['./cms-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CmsLandingComponent extends BasePageComponentDirective implements OnInit {
  public pageParam: IPageParam = { path: '' };

  // Came from the resolver
  public landingPageFromResolver: IPageLanding;

  public defaultModalConfig: MatDialogConfig = {
    disableClose: false,
    maxWidth: 600
  };

  constructor(
    private meta: Meta,
    private router: Router,
    private dialogService: MatDialog,
    protected readonly store$: Store<IAppState>,
    protected readonly localeService: LocaleService,
    protected readonly transferState: TransferState,
    protected readonly helpersService: HelpersService,
    protected readonly platformService: PlatformService,
    protected readonly userUtilsService: UserUtilsService,
    protected readonly searchStateMappingService: SearchStateMappingService,
    @Inject(PLATFORM_ID) protected platformId: Object,
    public route: ActivatedRoute
  ) {
    super(
      store$,
      localeService,
      platformService,
      userUtilsService,
      helpersService,
      searchStateMappingService,
      transferState,
      platformId,
      'landing'
    );
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    // Dispach the [Navigation] set page parameters
    this.store$.dispatch(new SetPageParams({ pageType: 'landing' }));
  }

  public ngOnInit() {
    const landingPathArray = this.router.url.split('/');

    if (landingPathArray.length > 2) {
      this.pageParam['path'] = landingPathArray[2];
    }

    this.route.data.subscribe(
      data => {
        if (data.CMS) {
          this.landingPageFromResolver = data.CMS;

          this.store$.dispatch(
            new Persist({
              ...data.pageAnalytics,
              pageUrl: data.CMS.tracking
            })
          );
        }
      },
      error => console.log('CMS Landing page error Router subscribe :', error)
    );

    this.meta.updateTag({ name: 'robots', content: 'noindex' });
  }

  public openPopin(type: 'directShippingBuyer' | 'expressDelivery' | 'bestOfUs' | 'bestOfAsia') {
    this.dialogService.open(ModalDeliveryServiceDescriptionComponent, {
      maxWidth: 600,
      data: {
        type,
        region: this.localeService.getRegionCode()
      }
    });
  }
}
